import { getNamedAnalysis } from "routes/sfg20-admin/plugins/system-info/activity-tab/controller/get-named-analysis"
import { Box, CircularProgress, Typography } from "@mui/material"
import React from "react"
import { AnalysisTimeSeriesGraph } from "routes/sfg20-admin/plugins/system-info/activity-tab/graphs/analysis-time-series-graph"

export function NavigateByHour({ reportDuration, granularity }) {
    const data =
        getNamedAnalysis.useResults("metric-by-hour", reportDuration, granularity, { metric: "navigate" }) ?? {}

    if (!data.results) {
        return (
            <>
                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                    <CircularProgress />
                </Box>
                <Typography mt={4} variant="subtitle1" sx={{ width: "100%", textAlign: "center", marginBottom: 2 }}>
                    Navigates per Hour
                </Typography>
            </>
        )
    }

    const { results } = data
    const sortedResults = [...results].sort((a, b) => new Date(a.timeStamp) - new Date(b.timeStamp))
    const graphData = sortedResults.map(({ timeStamp, recordCount }) => ({
        x: timeStamp,
        y: recordCount,
    }))

    return (
        <AnalysisTimeSeriesGraph
            granularity={granularity}
            title={`Navigation Events per ${granularity} - Last ${reportDuration} day(s)`}
            data={graphData}
        />
    )
}
